import parser from './parser';

const name = 'frame';


export default {parser, name};
